module.exports = __webpack_public_path__ + "img/SwissTrust2.61f2bb41.png";